import type { ReactNode, RefObject } from "react";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { Combobox } from "@circle-react-uikit/Combobox";
import { defaultDisplayValue } from "./defaultDisplayValue";

export interface SearchableSelectDropdownProps<T = unknown> {
  button: ReactNode;
  buttonRef?: RefObject<HTMLButtonElement> | null;
  children: ReactNode;
  displayValue?: (option: T) => string;
  onChange?: (value: T) => void;
  onClose?: () => void;
  onFilter?: (value: string) => void;
  optionsClassName?: string;
  placeholder?: string;
  value?: T;
}

const SearchableSelectDropdownComponent = <T,>({
  button,
  buttonRef = null,
  children,
  displayValue = defaultDisplayValue,
  onChange = noop,
  onClose = noop,
  onFilter = noop,
  optionsClassName,
  placeholder = t("select_an_option"),
  value,
}: SearchableSelectDropdownProps<T>) => (
  <Combobox value={value} onChange={onChange}>
    <Combobox.Button ref={buttonRef}>{button}</Combobox.Button>
    <Combobox.Options onClose={onClose} className={optionsClassName}>
      <Combobox.Input
        displayValue={displayValue}
        onChange={event => onFilter(event.target.value)}
        placeholder={placeholder}
      />
      <hr className="border-primary" />
      <Combobox.OptionsScrollableContainer>
        {children}
      </Combobox.OptionsScrollableContainer>
    </Combobox.Options>
  </Combobox>
);

export const SearchableSelectDropdown = Object.assign(
  SearchableSelectDropdownComponent,
  {
    EmptyOption: Combobox.EmptyOption,
    Option: Combobox.Option,
  },
);
